/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_DirtyInputs */

const cs_builder_sync_dirty = /** @type {(inputs: Builder_Sync_DirtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typst upraven`)
};

const en_builder_sync_dirty = /** @type {(inputs: Builder_Sync_DirtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typst edited`)
};

/**
* | output |
* | --- |
* | "Typst edited" |
*
* @param {Builder_Sync_DirtyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_dirty = /** @type {((inputs?: Builder_Sync_DirtyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_DirtyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_dirty(inputs)
	return cs_builder_sync_dirty(inputs)
});